module.exports = __webpack_public_path__ + "beauty.b8bb6c65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/retailers/beauty.png
// module id = 1740
// module chunks = 0